module.exports = __webpack_public_path__ + "static/media/viadeo.97304ea7.svg";